import React, { useCallback, useState } from "react";
import config from 'cityads-v3/config';

import Alert, { AlertProps } from '@mui/material/Alert';
import { SnackbarProps } from "@mui/material/Snackbar";

type UseSnackbar = Pick<SnackbarProps, 'onClose' | 'open' | 'autoHideDuration' | 'children'>
  & {
    handleOpen: () => void,
  }

type useSnackbarProps = Pick<AlertProps, 'severity'>
  & Pick<SnackbarProps, 'message'>;

export function useSnackbar({ severity, message }: useSnackbarProps): UseSnackbar {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen])

  const onClose: SnackbarProps['onClose'] = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const children = severity ? (
    <Alert severity={severity}>{message}</Alert>
  ) : undefined;

  return {
    autoHideDuration: config.SNACKBAR_AUTOHIDE_DURATION,
    open,
    onClose,
    handleOpen,
    children
  }
}
